import { put } from "redux-saga/effects";
import { ApiCaller, Utils } from "../../config";
import { JobActions } from "../actions";

export default class JobMiddleware {
    static *getJobs(params) {
        const { payload } = params;
        console.log("payload in getJobs middleware", payload);

        try {
            let res = yield ApiCaller.Get(`/admin/job?limit=${payload?.limit}&offset=${payload?.offset}${payload?.startDate && `&startDate=${payload?.startDate}`}${payload?.endDate && `&endDate=${payload?.endDate}`}&search=${payload?.search}${payload?.status && `&status=${payload?.status}`}${payload?.jobType && `&jobType=${payload?.jobType}`}`);
            if (res?.status == 200) {
                yield put(JobActions.getAllJobsSuccess(res?.data?.data));
            } else {
                yield put(JobActions.getAllJobsFailure());
                Utils.showSnackBar({
                    message: res?.data?.error?.message,
                    severity: "error",
                });
            }
        } catch (error) {
            yield put(JobActions.getAllJobsFailure());
            Utils.showSnackBar({
                message: error?.data?.error?.message,
                severity: "error",
            });
        }
    }

    static *exportJobs(params) {
        const { payload, cb } = params;
        try {
            let res = yield ApiCaller.Get(`/admin/export/job?limit=${payload?.limit}&offset=${payload?.offset}${payload?.startDate && `&startDate=${payload?.startDate}`}${payload?.endDate && `&endDate=${payload?.endDate}`}&status=${payload?.status}&search=${payload?.search}`);
            if (res?.status == 200) {
                Utils.showSnackBar({ message: res?.data?.data?.message });
                // console.log('res?.data?.data?.url', res?.data?.data?.url);
                cb && cb(res?.data?.data?.url)
            } else {
                Utils.showSnackBar({
                    message: res?.data?.error?.message,
                    severity: "error",
                });
            }
        } catch (error) {
            Utils.showSnackBar({
                message: error?.data?.error?.message,
                severity: "error",
            });
        }
    }

    static *JobDetail(params) {
        const { payload, cb } = params;
        // console.log(payload)
        try {
            let res = yield ApiCaller.Get(`/admin/job/${payload}`);
            if (res?.status == 200) {
                console.log("res?.data?.data", res?.data?.data);
                Utils.showSnackBar({ message: res?.data?.data?.message });
                yield put(JobActions.jobDetailSuccess(res?.data?.data));
                cb && cb()
            } else {
                yield put(JobActions.jobDetailFailure());
                Utils.showSnackBar({
                    message: res?.data?.error?.message,
                    severity: "error",
                });
            }
        } catch (error) {
            yield put(JobActions.jobDetailFailure());
            Utils.showSnackBar({
                message: error?.data?.error?.message,
                severity: "error",
            });
        }
    }

    static *GetServiceProviders(params) {
        const { payload, cb } = params;
        // console.log(payload)
        try {
            // as for now setting radius as high as possible and setting limit as max because we dont have radius picker in panel yet and also no requirement of infinite scroll implementation for sps listing.
            // also lat, lng is setting from the job response.
            let res = yield ApiCaller.Get(`/service/service-provider?latitude=${payload?.latitude}&longitude=${payload?.longitude}&radius=${payload?.radius || 100}&limit=${payload?.limit}`);
            if (res?.status == 200) {
                // alert('GetServiceProviders middle')
                // console.log("res?.data?.data", res?.data?.data);
                Utils.showSnackBar({ message: res?.data?.data?.message });
                yield put(JobActions.getServiceProvidersSuccess(res?.data?.data?.serviceProviders));
                cb && cb()
            } else {
                yield put(JobActions.getServiceProvidersFailure());
                Utils.showSnackBar({
                    message: res?.data?.error?.message,
                    severity: "error",
                });
            }
        } catch (error) {
            yield put(JobActions.getServiceProvidersFailure());
            Utils.showSnackBar({
                message: error?.data?.error?.message,
                severity: "error",
            });
        }
    }

    static *AssignServiceProvider(params) {
        const { payload, cb } = params;
        // console.log('payload in AssignServiceProvider middleware',payload)
        try {
            let res = yield ApiCaller.Patch(`/admin/job/assign/${payload?.jobId}`, { serviceProviderId: payload?.serviceProviderId });
            if (res?.status == 200) {
                // alert('AssignServiceProvider middle')
                // console.log("res?.data?.data", res?.data?.job);
                Utils.showSnackBar({ message: res?.data?.data?.message });
                yield put(JobActions.assignServiceProviderSuccess(res?.data?.job));
                cb && cb()
            } else {
                yield put(JobActions.assignServiceProviderFailure());
                Utils.showSnackBar({
                    message: res?.data?.error?.message,
                    severity: "error",
                });
            }
        } catch (error) {
            yield put(JobActions.assignServiceProviderFailure());
            Utils.showSnackBar({
                message: error?.data?.error?.message,
                severity: "error",
            });
        }
    }


}


// payload: {
//     limit: 10,
//     offset: 0,
//     page: 1,
//     search: '',
//     status: 'all',
//     startDate: '',
//     endDate: ''
//   },